import styled from 'styled-components';

export const StyledTemplateHeading = styled.div``;
